/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AgentConnectionBlock,
  AgentConnectionBlock$inboundSchema,
} from "./agentconnectionblock.js";

export type ListAgentConnectionBlocksResult = {
  /**
   * Blocks the caller wrote on their own connections
   */
  items: Array<AgentConnectionBlock>;
  /**
   * Cursor for the next page; absent when exhausted.
   */
  nextCursor?: string | undefined;
};

/** @internal */
export const ListAgentConnectionBlocksResult$inboundSchema: z.ZodMiniType<
  ListAgentConnectionBlocksResult,
  unknown
> = z.pipe(
  z.object({
    items: z.array(AgentConnectionBlock$inboundSchema),
    next_cursor: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "next_cursor": "nextCursor",
    });
  }),
);

export function listAgentConnectionBlocksResultFromJSON(
  jsonString: string,
): SafeParseResult<ListAgentConnectionBlocksResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListAgentConnectionBlocksResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListAgentConnectionBlocksResult' from JSON`,
  );
}
